import { Spacing, spacingVar } from '@constants/spacing';
import styled from '@emotion/styled';
import { HTMLAttributes, JSX } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
    spacing?: Spacing;
    align?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
    justify?: 'center' | 'flex-start' | 'flex-end' | 'space-between' ;
    fullWidth?: boolean;
    fullHeight?: boolean;
    as?: 'div' | 'section' | 'article' | 'main' | 'nav' | 'ul' | 'ol' | 'li';
}

function Row(props: Props) {
    const {
        spacing,
        align = 'center',
        fullWidth = false,
        justify = 'flex-start',
        as = 'div',
        fullHeight = false,
        ...rest
    } = props;
    return (<Component justify={justify}
        as={as}
        align={align}
        spacing={spacing}
        fullWidth={fullWidth}
        fullHeight={fullHeight}
        {...rest} />
    );
}

const Component = styled('div')<{
    as?: keyof JSX.IntrinsicElements;
    justify: string;
    align: string;
    spacing?: Spacing;
    fullWidth: boolean;
    fullHeight: boolean;
}>`
    display: flex;
    flex-direction: row;
    justify-content: ${({ justify }) => justify};
    align-items: ${({ align }) => align};
    column-gap: ${({ spacing }) => spacingVar(spacing)};
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
    height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
`;

export default Row;
